import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const StyledMainLayout = styled.section`
  margin: auto;
  padding-left: ${rem('24px')};
  padding-right: ${rem('26px')};
  padding-top: ${rem('55px')};
  ${mediaqueries.lessThan('mobile')`
    padding-left: ${rem('15px')};
    padding-right: ${rem('15px')};
    padding-top: ${rem('25px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    max-width: ${rem('1223px')};
    padding-left:0;
    padding-right:0;
  `};
`;

export { StyledMainLayout };
